// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__391pc","label":"Radio_label__2sRXs","checkMark":"Radio_checkMark__3wchf","disabled":"Radio_disabled__3Al3j"};